// There is only a single validator, and therefore a single 'ignore'.  So to be able to add more than one ignore handler, we have
// to use our own handler than then compiles a running list
$.validator.ignore = function ignore(functionOrSelector) { ignore.list.push(functionOrSelector); };
$.validator.ignore.list = [];

// There are use cases where things that are hidden or would otherwise be ignored we want to make sure to specifically include
// in validation, this allows for that
$.validator.include = function include(functionOrSelector) { include.list.push(functionOrSelector); };
$.validator.include.list = [];

// Add the validation default of ignoring hiddens
$.validator.ignore(":hidden");

// Default behavior doesn't pick up visibility:hidden
$.validator.ignore(function (index, element) {
    if ($(element).css("visibility") == "hidden") {
        return true;
    }
});

// Custom client-side validation for fields annotated with ValueFormat attribute. This 
// adds rules and configuration to jquery.validator.unobtrusive to support validating supported
// format.
// 
// Adding support for new formats is done by declaring supported formats in ValueFormatClientModelValidator
// and adding necessary adapters, rules, and validation methods here.
//
(function () {

    // configure jquery-validation default values
    $.validator.setDefaults({

        // There is only a single validator, and therefore a single 'ignore'.  So to be able to add more than one ignore handler, we have
        // to use our own handler than then compiles a running list
        ignore: function (index, element) {

            // Check the list to see if any entries return 'true' against the given index\element
            function check(list) {

                // Go through each configured entry in our list 
                for (const entry of list) {

                    // If it is a function, just call it
                    if (entry instanceof Function) {
                        if (entry.call(entry, index, element)) {
                            return true;
                        }
                    }

                    // If it is a string, then we assume it is a selector
                    if (Object.prototype.toString.call(entry) === "[object String]") {
                        if ($(element).is(entry)) {
                             return true;
                        }
                    }
                }

                return false;
            }

            // We ignore if a) something from the ignore list returns true, and b) nothing from the include list returns true
            return check($.validator.ignore.list) && !check($.validator.include.list);
        },

        // handle invalid form submission with the form-submission module
        invalidHandler: rs.module("common/form-submission").onInvalidFormSubmit
    });
    
    $.validator.unobtrusive.adapters.add("currency", [ /* adapter parameters */ ], function (options) {

        // execute the decimal validation method, passing along the precision and scale provided by the ValueFormatClientModelValidator
        options.rules["decimal"] =
        {
            scale: 2
        };

        // we want all standard validators to run (range, regex, etc), but we need to strip our formatting from
        // the value first.  This is done by attaching a normalizer function which cleans
        // the value before it is run through the designated validators
        options.rules["normalizer"] = function (value) {

            // this can be found in jquery.normalization.js
            return $.getNormalizedCurrencyValue(value);
        };

        // the standard number validation will also be run like we want, BUT we dislike the error message.  So update it.
        if (options.messages["number"]) {
            options.messages["number"] = options.messages["number"].replace(/number.$/, 'dollar amount.');
        }

        // set our custom message, which ultimately comes from the html attributge data-val-currency
        options.messages["decimal"] = options.message;
    });

    $.validator.unobtrusive.adapters.add("datetime", [ /* adapter parameters */], function (options) {
        options.rules["datetime"] = {};

        // set our custom message, which ultimately comes from the html attribute data-val-datetime
        options.messages["datetime"] = options.message;
    });

    $.validator.addMethod("datetime", function (value, element, param) {

        // catch "partial" date/time entry
        if (value.length == 0 && element.validity && element.validity.badInput) {
            return false;
        }

        return true;
    });

    $.validator.unobtrusive.adapters.add("datetimerange", [ "min", "max" ], function (options) {
        options.rules["datetimerange"] =
        {
            min: options.params.min ? new Date(options.params.min) : null,
            max: options.params.max ? new Date(options.params.max) : null
        };

        options.messages["datetimerange"] = options.message;
    })

    $.validator.addMethod("datetimerange", function (value, element, params) {

        if (value.length == 0) {
            return true;
        }

        // use params.min, params.max to validate value
        try {
            var inputDate = new Date(value);

            if (params.min && params.max) {
                return params.min <= inputDate && params.max >= inputDate;
            }
            else if (params.min) {
                return params.min <= inputDate;
            }
            else if (params.max) {
                return parmas.max >= inputDate;
            }
        }
        catch {

        }


        return false;
    });

    $.validator.unobtrusive.adapters.add("ssn", [ /* adapter parameters */ ], function (options) {

        options.rules["ssn"] = {};

        // we want all standard validators to run (range, regex, etc), but we need to strip our formatting from
        // the value first.  This is done by attaching a normalizer function which cleans
        // the value before it is run through the designated validators
        options.rules["normalizer"] = function (value) {

            // strip out the dashes (this can be found in jquery.normalization.js)
            return $.getNormalizedIDValue(value);
        };

        // set our custom message, which ultimately comes from the html attribute data-val-currency
        options.messages["ssn"] = options.message;
    });

    // Add the ssn validation method
    $.validator.addMethod("ssn", function (value) {
        return value.length == 0 || (value.length == 9 && /^\d+$/.test(value));
    });

    $.validator.unobtrusive.adapters.add('fein', [ /* adapter parameters */], function (options) {

        options.rules['fein'] = {};

        // we want all standard validators to run (range, regex, etc), but we need to strip our formatting from
        // the value first.  This is done by attaching a normalizer function which cleans
        // the value before it is run through the designated validators
        options.rules['normalizer'] = function (value) {

            // strip out the dashes (this can be found in jquery.normalization.js)
            return $.getNormalizedIDValue(value);
        };

        // set our customer message, which ultimately comes from the html tag data-val-currency
        options.messages['fein'] = options.message;
    });

    // Add the fein validation method
    $.validator.addMethod("fein", function (value) {
        return value.length == 0 || (value.length == 9 && /^\d+$/.test(value));
    });


    // Add an adapter for handling percent valueformats
    $.validator.unobtrusive.adapters.add("percent", ["precision", "scale", "name"], function (options) {

        // execute the decimal validation method, passing along the precision and scale provided by the ValueFormatClientModelValidator
        options.rules["decimal"] =
        {
            precision: options.params.precision,
            scale: options.params.scale,
            name: options.params.name,

            // adding this as a rule parameter since we're using a message factory for dynamic messages
            message: options.message
        };

        // we want all standard validators to run (range, regex, etc), but we need to strip our formatting from
        // the value first.  This is done by attaching a normalizer function which cleans
        // the value before it is run through the designated validators
        options.rules["normalizer"] = function (value) {

            // strip out percent character, spaces, and commas (this can be found in jquery.normalization.js)
            return $.getNormalizedPercentValue(value);
        }
    });

    // Add an adapter for handling decimal valueformats
    $.validator.unobtrusive.adapters.add("decimal", ["precision", "scale", "name"], function (options) {

        // execute the decimal validation method, passing along the precision and scale provided by the ValueFormatClientModelValidator
        options.rules["decimal"] =
        {
            precision: options.params.precision,
            scale: options.params.scale,
            name: options.params.name,

            // adding this as a rule parameter since we're using a message factory for dynamic messages
            message: options.message
        };

        // we want all standard validators to run (range, regex, etc), but we need to strip our formatting from
        // the value first.  This is done by attaching a normalizer function which cleans
        // the value before it is run through the designated validators
        options.rules["normalizer"] = function (value) {

            // strip out spaces and commas (this can be found in jquery.normalization.js)
            return $.getNormalizedDecimalValue(value);
        }
    });

    // Add an adapter for handling integers 
    $.validator.unobtrusive.adapters.add("integer", [ /* adapter parameters */ ], function (options) {
        // jquery validation additional-methods.js includes integer validation, use it
        options.rules["integer"] = true;

        // but the original error message is garbage so we override it 
		options.messages['integer'] = options.message;
    });

    // Validation method for ensuring the number of significant decimal places conforms to the 
    // field's precision and scale requirements.   Used for both Percent and Decimal ValueFormat validation.
    $.validator.addMethod("decimal", function (value, element, params) {
        // construct a regex which verifies the scale passed in from the adapter
        var numberRegex = new RegExp(`^\s*-?\s*(\\d*)(\.\\d*)?$`);
        var match = numberRegex.exec(value);

        // default the error message to the static one
        params.failureMessage = params.message;

        if (match) {
            var integer = match[1];
            var decimalsLeft = Number(params.precision) - Number(params.scale);
            if (integer.length > decimalsLeft) {
                params.failureMessage = "{name} must be up to " + decimalsLeft + " digits before the decimal point.";
                return false;
            }

            var dotPlus = match[2];
            if (dotPlus) {
                // strip trailing zeros, as they don't contribute to the number of significant digits
                dotPlus = dotPlus.replace(/0+$/g, '');

                var result = dotPlus.length <= (Number(params.scale) + 1);
                if (!result) {
                    if (params.scale == 0) {
                        params.failureMessage = "{name} must be a whole number.";
                    }
                }

                return result;
            }
            else {
                return true;
            }
        }
        else {
            // Not a number format we support
            return false;
        }
    },

    // dynamic error message generator
    function (params, element) {
        var message = params.failureMessage;    

        // do string replace of tokens in the message from param values
        for (var key in params) {
            if (!(key == 'failureMessage' || key == 'message')) {
                var token = "{" + key + "}";
                message = message.replace(token, params[key]);
            }
        }

        return message;
        });

    // Add an adapter for validating field is not equal to others 
    $.validator.unobtrusive.adapters.add("notequal", ["otherproperties"], function (options) {

        // Get array of properties the current property needs to validate against
        let otherProperties = options.params.otherproperties.split(",");

        // Get the normalizer for this element
        var thisNormalizer = options.rules['normalizer'];
        if (thisNormalizer == undefined) {
            thisNormalizer = function (value) { return value; };
        }

        // loop on each property and setup a rule/validation method for each
        for (let property of otherProperties) {

            // get the element to compare to
            var compareElement = $(options.element.form).find(`#${property}`);

            // only set up a rule if the element is found in the current form
            if (compareElement.length > 0) {

                let ruleName = `notequal_${property}`;

                options.rules[ruleName] = { compareElement: compareElement };
                options.messages[ruleName] = $(options.element).data(`val-notequal-${property}`);

                $.validator.addMethod(ruleName, function (value, element, params) {

                    // If either value is empty, short circuit - no need to compare
                    if (value == "" || params.compareElement.val() == "") {
                        return true;
                    }

                    // Get lowercase values to compare
                    var thisValue = value.toLowerCase();
                    var otherValue = params.compareElement.val().toLowerCase();

                    // Get the normalizer for the compare element
                    var otherNormalizer;
                    if (params.compareElement.rules() == undefined || params.compareElement.rules()["normalizer"] == undefined) {
                        otherNormalizer = function (value) { return value; };
                    }
                    else {
                        otherNormalizer = params.compareElement.rules()["normalizer"];
                    }

                    // Compare each combination of normalizer and value
                    return thisNormalizer(thisValue) != thisNormalizer(otherValue) &&
                            thisNormalizer(thisValue) != otherNormalizer(otherValue) &&
                            otherNormalizer(thisValue) != otherNormalizer(otherValue) &&
                            otherNormalizer(thisValue) != thisNormalizer(otherValue);
                });
            }
        }
    });

    // override the Time validation to support .NET's compliance with RFC3339 (Html5DateRenderingMode == HtmlDateRenderingMode.Rfc3339) in the framework's InputTagHelper.cs, 
    // which includes milliseconds.
    $.validator.addMethod("time", function (value, element) {
        return this.optional(element) || /^([01]\d|2[0-3]|[0-9])(:[0-5]\d){1,2}(\.\d{3})?$/.test(value);
    }, "Value must be between 00:00 and 23:59");

    // Add an adapter for handling the istrue validation
    $.validator.unobtrusive.adapters.add("istrue", [ /* adapter parameters */], function (options) {

        // execute the istrue validation method
        options.rules["istrue"] = {};

        // set our custom message
        options.messages["istrue"] = options.message;
    });

    // Add the istrue validation method
    $.validator.addMethod("istrue", function (value, element, params) {
        return element.checked;
    });

    // Raise an error if file(s) have errors
    $.validator.addMethod("filesWithErrors", function (value, element, params) {
        // Get the currently chosen files from the instance api
        var chosenFiles = params.instanceApi.getChosenFiles();
        if (chosenFiles.length == 0) {
            return true;
        }

        return chosenFiles.every((file) => !file.failed);
    }, "One or more files have errors.");

    // Raise an error if file(s) aren't finished uploading yet
    $.validator.addMethod("filesNotUploaded", function (value, element, params) {
        // Get the currently chosen files from the instance api
        var chosenFiles = params.instanceApi.getChosenFiles();
        if (chosenFiles.length == 0) {
            return true;
        }

        return chosenFiles.every((file) => file.uploaded);
    }, "One or more files have not finished processing.");

    // reset validation on the supplied form
    $.validator.resetValidation = function (form) {
        form.validate().destroy();
        form.removeData("unobtrusiveValidation");
        $.validator.unobtrusive.parse(form);
        $(form).data("validator", form.validate());
    };
})();

(function ($) {
    'use strict';

    /// Clears jquery validation errors related to the element, both the internal
    /// jquery validation error list and the user-facing error labels.  This is 
    //  the preferred alternative to .valid(), which causes re-validation of an element.
    function clearErrors() {

        // Get the validator from the parent form, not using the typical .validator() because 
        // that will instantiate the validator if it doesn't exist, which we do not want because it
        // interferes with proper validation configuration during page load.
        var validator = this.closest("form").data("validator");
        if (validator) {
            this.each(function () {

                var input = this;

                // Remove all custom classes relating to errors on the input itself.  Passing as array, otherwise
                // when a Select element comes in, it's as if resetElements is being called on its contained options 
                // and it fails.
                validator.resetElements([input]);

                // Clear the text of the associated error label for the input.
                validator.showLabel(input, "");

                // Remove generated errors for the input element from the error list so they don't
                // re-appear unless and until validation occurs again
                validator.errorList = validator.errorList.filter(function (error) {
                    return error.element != input;
                });
            });
        }

        return this;
    }

    jQuery.fn.extend({
        clearErrors
    });

})(jQuery);